import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Share2, Loader2 } from "lucide-react";

export function ConnectMetaDialog({ open, onOpenChange, saving, onConnect }) {
  const [accessToken, setAccessToken] = useState("");

  const handleConnect = () => {
    onConnect(accessToken, () => {
      setAccessToken("");
      onOpenChange(false);
    });
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <Share2 className="w-5 h-5 text-pink-600" />
            Conectar Meta
          </DialogTitle>
        </DialogHeader>
        <div className="space-y-4 py-4">
          <p className="text-sm text-muted-foreground">
            Cole o Access Token gerado no Facebook Developer:
          </p>
          <Textarea
            value={accessToken}
            onChange={e => setAccessToken(e.target.value)}
            placeholder="EAANKDm..."
            rows={3}
            data-testid="access-token-input"
          />
          <div className="text-xs text-muted-foreground space-y-1">
            <p>1. Acesse <a href="https://developers.facebook.com/tools/explorer" target="_blank" rel="noopener noreferrer" className="text-pink-600 underline">Graph API Explorer</a></p>
            <p>2. Selecione seu App</p>
            <p>3. Adicione as permissões necessárias</p>
            <p>4. Clique em "Generate Access Token"</p>
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>Cancelar</Button>
          <Button onClick={handleConnect} disabled={saving} className="bg-gradient-to-r from-pink-600 to-purple-600">
            {saving && <Loader2 className="w-4 h-4 mr-2 animate-spin" />}
            Conectar
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
